export default __webpack_public_path__ + "static/media/Logo_Cartondotcom.4ff0014d.png";